"use client";
import { useRef } from "react";
import { motion, useInView } from "framer-motion";
import Image from "next/image";
import Link from "next/link";
import ArrowLeft from "@/components/icons/arrow-left";

const AnimatedLinkBoxes = ({ importantLinks, hotLinks }) => {
  const leftRef = useRef(null);
  const isLeftInView = useInView(leftRef, { once: true, margin: "-50px" });

  const containerVariants = {
    visible: {
      transition: {
        staggerChildren: 0.15,
      },
    },
    hidden: {},
  };

  const itemVariants = {
    hidden: { opacity: 0, y: -100 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        type: "spring",
        stiffness: 100,
        damping: 12,
      },
    },
  };

  return (
    <section className="my-1 md:my-2">
      <div className="md:flex justify-center gap-x-5">
        <div className="relative my-2 md:w-[45vw] lg:w-[35vw] bg-gray-1 rounded-lg overflow-hidden p-1.5 md:p-3">
          <div className="absolute bottom-0 right-0 h-28 w-28 bg-[#b3c7f9] opacity-20 rounded-full translate-x-1/4 translate-y-1/4 z-0"></div>
          <h3 className="bg-green-10 text-green-9 p-1 md:p-2 font-medium text-base lg:font-semibold lg:text-lg w-fit rounded-md md:m-2 px-1 md:px-4 z-10 relative border border-l-4 border-l-green-9">
            {importantLinks.title}
          </h3>
          <motion.div
            ref={leftRef}
            variants={containerVariants}
            initial="hidden"
            animate={isLeftInView ? "visible" : "hidden"}
          >
            {importantLinks.links.map((item, i) => (
              <motion.div key={i} variants={itemVariants}>
                <Link
                  href={item.url}
                  target={item.url === "https://parichay.nic.in/pnv1/assets/login?sid=1234567899" ? '_blank' : null}
                  className="py-1 lg:px-0 flex items-center group relative z-10 w-fit"
                >
                  <span className="underline font-medium  lg:font-semibold lg:text-lg group-hover:text-lg text-gray-600 px-1 md:px-2 hover:text-green-1 py-1 lg:py-2">
                    {item.name}
                  </span>
                  <ArrowLeft className="size-5 ml-2 opacity-0 group-hover:opacity-100 rotate-180 group-hover:text-green-1 transition-opacity duration-300" />
                </Link>
              </motion.div>
            ))}
          </motion.div>
        </div>
        {/* Right box data*/}
        <div className="relative my-2 md:w-[45vw] lg:w-[55vw] bg-gray-1 rounded-lg overflow-hidden p-1.5 md:p-3">
          <div className="absolute top-0 right-0 h-32 w-32 bg-[#b3c7f9] opacity-20 rounded-full translate-x-1/4 -translate-y-1/4 z-0"></div>
          <Image
            src={hotLinks.images.icon.src}
            alt={hotLinks.images.icon.alt}
            className="absolute bottom-4 right-4 h-24 w-24 z-10"
            width={64}
            height={64}
            unoptimized
          />
          
          <h3 className="bg-green-10 text-green-9 p-1 md:p-2 font-medium text-base lg:font-semibold lg:text-lg w-fit rounded-md md:m-2 px-1 md:px-4 z-10 relative border border-l-4 border-l-green-9">
            {hotLinks.title}
          </h3>
          <motion.div
            ref={leftRef}
            variants={containerVariants}
            initial="hidden"
            animate={isLeftInView ? "visible" : "hidden"}
          >
            {hotLinks.links.map((item, i) => (
              <motion.div key={i} variants={itemVariants}>
                <Link
                target="_blank"
                  href={item.url}
                  className="py-1 lg:px-0 flex items-center group relative z-10 w-fit"
                >
                  <span className="underline font-medium  lg:font-semibold lg:text-lg group-hover:text-lg text-gray-600 px-1 md:px-2 hover:text-green-1 py-1 lg:py-2">
                    {item.name}
                  </span>
                  <ArrowLeft className="size-5 ml-2 opacity-0 group-hover:opacity-100 rotate-180 group-hover:text-green-1 transition-opacity duration-300" />
                </Link>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AnimatedLinkBoxes;
